import { Metamodel } from 'app/model/base/model';
import { IValidationContext, IViolation } from 'shell-models-lib';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { DataFlowSource } from '../dataflow-source';
import { DataFlowSink } from '../dataflow-sink';
import { validateFilePathOfFileBasedSettings } from './dataset-settings-validation-utils';
import { ParquetSettings } from './parquet-settings';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.parquetInline.dataflowSettings,
    validator: ParquetInlineSettings.validateParquetSettings
})
export class ParquetInlineSettings extends ParquetSettings {
    public compressionType: string;

    public getIconClass(): string {
        return 'i-20x20-Parquet';
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateParquetSettings(settings: ParquetInlineSettings, context: IValidationContext): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        if (settings.transform instanceof DataFlowSource) {
            const source = settings.transform;
            if (source.isInlineDataset && source.datasetSettings && source.datasetSettings.getFormat() === DatasetFormatType.Parquet) {
                violations.push(...(await validateFilePathOfFileBasedSettings(settings, false, context)));
            }
        }

        if (settings.transform instanceof DataFlowSink) {
            const sink = settings.transform;
            if (sink.isInlineDataset && sink.datasetSettings && sink.datasetSettings.getFormat() === DatasetFormatType.Parquet) {
                violations.push(...(await validateFilePathOfFileBasedSettings(settings, true, context)));
            }
        }

        return violations.length > 0 ? violations : undefined;
    }
}
